import { render, staticRenderFns } from "./global-errors.vue?vue&type=template&id=428383e8&"
import script from "./global-errors.ts?vue&type=script&lang=js&"
export * from "./global-errors.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports